<script setup lang="ts">
const props = defineProps<{
  subcategory: SubCategory
}>()

const { styles } = useVariants('menuSubCategory')

const filter = useAllergenFilter()

const visibleItems = computed(() =>
  filter ? props.subcategory.items.filter(filter.isItemVisible) : props.subcategory.items,
)
</script>

<template>
  <div v-if="visibleItems.length" :class="styles.base()">
    <div>
      <h3 v-if="subcategory.title" :class="styles.title()">
        {{ subcategory.title }}
      </h3>
      <p v-if="subcategory.description" :class="styles.description()">
        {{ subcategory.description }}
      </p>
    </div>
    <MenuItem
      v-for="item in visibleItems"
      :key="item.title"
      :item="item"
    />
  </div>
</template>
